var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NewsFinderAndCreator',{key:_vm.componentRefreshKey,attrs:{"isNeedCreate":true,"changed-item":_vm.changedItem,"additionalGetParameter":_vm.additionalGetParameter,"typeOfTableFilter":_vm.$route.params.category ? '' : 'news'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }